import { TextFieldProps } from "./TextField.types";
import { TextField as BaseTextField } from "@commonlibs";
import TextFieldLabel from "./TextFieldLabel/TextFieldLabel";
import TextFieldSuffix from "./TextFieldSuffix/TextFieldSuffix";
import clsx from "clsx";
import { forwardRef } from "react";

const TextField = forwardRef(
    (
        { variant = "outlined", size = "md", className, label, showOptional, suffix, required, ...rest }: TextFieldProps,
        ref,
    ): JSX.Element => {
        return (
            <BaseTextField
                ref={ref}
                suffix={<TextFieldSuffix suffix={suffix} />}
                label={typeof label === "string" ? <TextFieldLabel label={label} showOptional={showOptional} required={required} /> : label}
                required={required}
                className={clsx(className, size.capitalize(), variant.capitalize())}
                {...rest}
            />
        );
    },
);

export default TextField;
